import Vue from 'vue'
import Vuex from 'vuex'
import { Menu } from "@/modules/Menu";
import { MainteInfo } from "@/modules/MainteInfo";
import { SheetListCondition } from "@/modules/teacher/SheetList";
import { SheetListCondition as ApprovalSheetListCondition } from "@/modules/teacher/ApprovalSheetList";
import { SheetListCondition as LessonSheetListCondition } from "@/modules/teacher/LessonSheetList";
import { SearchCondition as WebupListCondition } from "@/modules/teacher/WebupList"
import { SearchCondition as BaseSheetListCondition } from "@/modules/teacher/BaseSheetList"
import { SearchCondition as ApprovalBaseSheetListCondition } from "@/modules/teacher/ApprovalBaseSheetList"
import { SearchCondition as StudentListCondition } from "@/modules/teacher/StudentList"
import { SearchCondition as SaitenListCondition } from "@/modules/teacher/SaitenList"
import { SearchCondition as AutoReviewTemplateEditCondition } from "@/modules/teacher/AutoReviewTemplateEdit"
import { SearchCondition as ProgressSheetListCondition } from "@/modules/teacher/ProgressSheetList"
import { SearchCondition as ProgressStudentListCondition } from "@/modules/teacher/ProgressStudentList"
import { CopyBaseSheetSearchCondition as CopyBaseSheetCondition } from "@/modules/teacher/BaseSheetList"
import { CopyBaseSheetSearchCondition as CopyApprovalBaseSheetCondition } from "@/modules/teacher/ApprovalBaseSheetList"
import createPersistedState from 'vuex-persistedstate';
import * as Common from '../commons/common';
import router from "@/router/index";
import isMobileJS from 'ismobilejs'

Vue.use(Vuex)

export type StateType = {
  currentUser: any
  isShowOverlay: boolean
  overlayText: string
  isShowProgress: boolean
  progressText: string
  schools: any[]
  roles: any[]
  grades: any[]
  studentStatus: any[]
  sheetListCondition: SheetListCondition
  approvalSheetListCondition: ApprovalSheetListCondition
  lessonSheetListCondition: LessonSheetListCondition
  webupListCondition: WebupListCondition
  baseSheetListCondition: BaseSheetListCondition
  approvalBaseSheetListCondition: ApprovalBaseSheetListCondition
  studentListCondition: StudentListCondition
  saitenListCondition: SaitenListCondition
  autoReviewTemplateEditCondition: AutoReviewTemplateEditCondition
  progressSheetListCondition: ProgressSheetListCondition
  progressStudentListCondition: ProgressStudentListCondition
  copyBaseSheetCondition: CopyBaseSheetCondition
  copyApprovalBaseSheetCondition: CopyApprovalBaseSheetCondition
  isMobile: boolean
  isPhone: boolean
  isTablet: boolean
  isHeaderDisp: boolean
  mainteInfo: MainteInfo
  isKaitouViewReloaded: boolean
  isShowingMsgBox: boolean
  student_code: string
  student_name: string
  saitenTargetExamineeIds: number[]
  viewPoints: any[]
  scoring_types: any[]
  correct_texts: any[]
  gauthCredentials: string
  answer_types: any[]
  otp_login_id: string,
  base64_school_logo: string
  webup_type: number
  courses: any[]
  campuses: any[]
  classifications: any[]
  subjects: any[]
  curriculums: any[]
  lessons: any[]
  school_url_prefix: string
  is_preview_mode: boolean
  sheet_type: number
  is_parent: boolean
  students: any
  textDirection: number
  fontSize: number
  lineHeight: number
  isSSO: boolean
  studentSheetListDispSubjectCodes: string[]
  isFilterMisaiten: boolean | null
  kaitouToolbarPosition: number
}

export default new Vuex.Store({
  state: {
    currentUser: null,
    isShowOverlay: false,
    overlayText: "",
    isShowProgress: false,
    progressText: null,
    schools: [],
    roles: Common.GetComboboxRoleArray(),
    grades: Common.GetComboboxGradeArray(),
    studentStatus: Common.GetComboboxStudentStatusArray(),
    sheetListCondition: new SheetListCondition(),
    approvalSheetListCondition: new ApprovalSheetListCondition(),
    lessonSheetListCondition: new LessonSheetListCondition(),
    webupListCondition: new WebupListCondition(),
    baseSheetListCondition: new BaseSheetListCondition(),
    approvalBaseSheetListCondition: new ApprovalBaseSheetListCondition(),
    saitenListCondition: new SaitenListCondition(),
    progressSheetListCondition: new ProgressSheetListCondition(),
    progressStudentListCondition: new ProgressStudentListCondition(),
    autoReviewTemplateEditCondition: new AutoReviewTemplateEditCondition,
    copyBaseSheetCondition: new CopyBaseSheetCondition,
    studentListCondition: null,
    isMobile: isMobileJS(window.navigator).phone || isMobileJS(window.navigator).tablet,
    isTablet: isMobileJS(window.navigator).tablet,
    isPhone: isMobileJS(window.navigator).phone,
    isHeaderDisp: true,
    mainteInfo: new MainteInfo([]),
    isKaitouViewReloaded: false,
    isShowingMsgBox: false,
    student_code: null,
    student_name: null,
    saitenTargetExamineeIds: [],
    viewPoints: [],
    scoring_types: Common.GetComboboxScoingTypeArray(),
    correct_texts: Common.GetComboboxCorrectTextArray(),
    gauthCredentials: "",
    answer_types: Common.GetComboboxAnswerTypeArray(),
    otp_login_id: "",
    base64_school_logo: null,
    webup_type: null,
    courses: [],
    campuses: [],
    classifications: [],
    subjects: [],
    lessons: [],
    school_url_prefix: null,
    is_preview_mode: false,
    sheet_type: null,
    is_parent: false,
    textDirection: Common.DirectionEnum.Horizon,
    fontSize: null,
    lineHeight: null,
    isSSO: false,
    studentSheetListDispSubjectCodes: [],
    isFilterMisaiten: null,
    kaitouToolbarPosition: Common.ToolbarPositionEnum.Bottom,
  } as StateType,
  mutations: {
    setCurrentUser(state, user: any){
      state.currentUser = user;
    },
    setCurrentUserSchoolId(state, school_id: any){
      state.currentUser.school_id = school_id;
    },
    setCurrentUserSchoolOptions(state, school_options: any){
      state.currentUser.school_options = school_options;
    },
    setSchools(state, schools: []){
      state.schools = schools;
    },
    setSheetListCondition(state, condition: SheetListCondition){
      state.sheetListCondition = condition;
    },
    setApprovalSheetListCondition(state, condition: ApprovalSheetListCondition){
      state.approvalSheetListCondition = condition;
    },
    setLessonSheetListCondition(state, condition: LessonSheetListCondition){
      state.lessonSheetListCondition = condition;
    },
    setWebupListCondition(state, condition: WebupListCondition){
      state.webupListCondition = condition;
    },
    setBaseSheetListCondition(state, condition: BaseSheetListCondition){
      state.baseSheetListCondition = condition;
    },
    setApprovalBaseSheetListCondition(state, condition: ApprovalBaseSheetListCondition){
      state.approvalBaseSheetListCondition = condition;
    },
    setStudentListCondition(state, condition: StudentListCondition){
      state.studentListCondition = condition;
    },
    setSaitenListCondition(state, condition: SaitenListCondition){
      state.saitenListCondition = condition;
    },
    setProgressSheetListCondition(state, condition: ProgressSheetListCondition){
      state.progressSheetListCondition = condition;
    },
    setProgressStudentListCondition(state, condition: ProgressStudentListCondition){
      state.progressStudentListCondition = condition;
    },
    setAutoReviewTemplateEditCondition(state, condition: AutoReviewTemplateEditCondition){
      state.autoReviewTemplateEditCondition = condition;
    },
    setCopyBaseSheetCondition(state, condition: CopyBaseSheetCondition){
      state.copyBaseSheetCondition = condition;
    },
    setCopyApprovalBaseSheetCondition(state, condition: CopyApprovalBaseSheetCondition){
      state.copyApprovalBaseSheetCondition = condition;
    },
    setIsShowOverlay(state, isShow: boolean){
      state.isShowOverlay = isShow;
    },
    setOverlayText(state, text: string){
      state.overlayText = text;
    },
    setIsShowProgress(state, isShow: boolean){
      state.isShowProgress = isShow;
    },
    setProgressText(state, text: string){
      state.progressText = text;
    },
    setIsHeaderDisp(state, isHeaderDisp: boolean){
      state.isHeaderDisp = isHeaderDisp;
    },
    setMainteInfo(state, mainteInfos: any[]){
      state.mainteInfo = new MainteInfo(mainteInfos);
    },
    setIsKaitouViewReloaded(state, value){
      state.isKaitouViewReloaded = value;
    },
    setIsShowingMsgBox(state, isShowingMsgBox: boolean){
      state.isShowingMsgBox = isShowingMsgBox;
    },
    setStudentCode(state, value){
      state.student_code = value;
    },
    setStudentName(state, value){
      state.student_name = value;
    },
    setSaitenTargetExamineeIds(state, value){
      state.saitenTargetExamineeIds = value;
    },
    setViewPoints(state, viewPoints: []){
      state.viewPoints = viewPoints;
    },
    setGauthCredentials(state, credentials: string){
      state.gauthCredentials = credentials;
    },
    setOtpLoginId(state, otp_login_id: string){
      state.otp_login_id = otp_login_id;
    },
    setBase64SchoolLogo(state, base64_school_logo: string){
      state.base64_school_logo = base64_school_logo;
    },
    setWebupType(state, webup_type){
      state.webup_type = webup_type;
    },
    setCourses(state, courses){
      state.courses = courses;
    },
    setCampuses(state, campuses){
      state.campuses = campuses;
    },
    setClassifications(state, classifications){
      state.classifications = classifications;
    },
    setSubjects(state, subjects){
      state.subjects = subjects;
    },
    setCurriculums(state, curriculums){
      state.curriculums = curriculums;
    },
    setLessons(state, lessons){
      state.lessons = lessons;
    },
    setSchoolUrlPrefix(state, school_url_prefix){
      state.school_url_prefix = school_url_prefix;
    },
    setIsPreviewMode(state, is_preview_mode){
      state.is_preview_mode = is_preview_mode;
    },
    setSheetType(state, sheet_type){
      state.sheet_type = sheet_type;
    },
    // DBの帳票種別を採点設定画面のフロー種別へ正規化
    setScoringSettingSheetType(state, sheet_type){
      state.sheet_type = Common.isApprovalExamSheetType(sheet_type) ? Common.SheetTypeEnum.ApprovalExam : Number(sheet_type);
    },
    setIsParent(state, is_parent){
      state.is_parent = is_parent;
    },
    setStudents(state, students){
      state.students = students;
    },
    setTextDirection(state, direction){
      state.textDirection = direction;
    },
    setFontSize(state, fontSize){
      state.fontSize = fontSize;
    },
    setLineHeight(state, lineHeight){
      state.lineHeight = lineHeight;
    },
    setIsSSO(state, isSSO){
      state.isSSO = isSSO;
    },
    setStudentSheetListDispSubjectCodes(state, studentSheetListDispSubjectCodes){
      state.studentSheetListDispSubjectCodes = studentSheetListDispSubjectCodes;
    },
    setIsFilterMisaiten(state, isFilterMisaiten: boolean){
      state.isFilterMisaiten = isFilterMisaiten;
    },
    setKaitouToolbarPosition(state, position: number){
      state.kaitouToolbarPosition = position;
    }
  },
  getters: {
    // 採点可能科目プルダウン
    getComboboxScorableSubjects: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      for(const subject of state.currentUser.scorable_subjects){
        rtn.push({value: subject.subject_code, text: `${subject.subject_code}:${subject.name}`});
      }
      return rtn;
    },
    // 採点可能クラスプルダウン
    getComboboxScorableClassifications: (state) => (allowEmpty: boolean, includeDisable: boolean = false) => {
      
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      for(const classification of state.currentUser.scorable_classifications){
        if(!includeDisable && classification.status == 2){
          continue;
        }
        rtn.push({value: classification.class_code, text: `${classification.class_code} : ${classification.name}`});
      }
      return rtn;
    },
    // 学年プルダウン
    getComboboxGrades: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.grades);
    },
    // 学校プルダウン
    getComboboxSchools: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      for(const school of state.schools){
        rtn.push({value: school.id, text: `${school.id} : ${school.name}`});
      }
      return rtn;
    },
    getComboboxRoles: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.roles);
    },
    getRoleNameByValue: (state) => (value: string) => {
      const role = state.roles.filter(x => x.value == value);
      return role.length > 0 ? role[0].text : "-";
    },
    getComboboxStudentStatus: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(state.studentStatus);
    },
    getStudentStatusNameByValue: () => (code: number) => {
      return Common.getStudentStatusNameByValue(code);
    },
    // 観点プルダウン
    getComboboxViewPoints: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      for(const viewPoint of state.viewPoints){
        rtn.push({value: viewPoint.id, text: `${viewPoint.id} : ${viewPoint.name}`});
      }
      return rtn;
    },
    // 採点方法プルダウン
    getComboboxScoringTypes: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      return rtn.concat(state.scoring_types);
    },
    // 正答プルダウン
    getComboboxCorrectTexts: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      return rtn.concat(state.correct_texts);
    },
    getViewPointNameById: (state) => (id: number) => {
      const viewPoint = state.viewPoints.filter(x => x.id == id);
      return viewPoint.length > 0 ? viewPoint[0].name : "-";
    },
    // 解答方法プルダウン
    getComboboxAnswerTypes: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      return rtn.concat(state.answer_types);
    },
    getGradeNameByValue: (state, getters) => (value: number) => {
      const grade = state.grades.filter(x => x.value == value);
      return grade.length > 0 ? grade[0].text : "-";
    },
    getComboboxCourses: (state) => (allowEmpty: boolean, emptyText: string = "-") => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: emptyText});
      }
      for(const course of state.courses){
        rtn.push({value: course.course_code, text: `${course.course_code} : ${course.name}`});
      }
      return rtn;
    },
    getComboboxCampuses: (state) => (allowEmpty: boolean, emptyText: string = "-") => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: emptyText});
      }
      for(const campus of state.campuses){
        rtn.push({value: campus.campus_code, text: `${campus.campus_code} : ${campus.name}`});
      }
      return rtn;
    },
    getComboboxClassifications: (state) => (allowEmpty: boolean, emptyText: string = "-") => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: emptyText});
      }
      for(const classification of state.classifications){
        rtn.push({value: classification.class_code, text: `${classification.class_code} : ${classification.name}`});
      }
      return rtn;
    },
    getComboboxSubjects: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      for(const subject of state.subjects){
        rtn.push({value: subject.subject_code, text: `${subject.subject_code} : ${subject.name}`});
      }
      return rtn;
    },
    getComboboxCurriculums: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: null, text: "-"});
      }
      for(const curriculum of state.curriculums){
        rtn.push({value: curriculum.curriculum_code, text: `${curriculum.curriculum_code} : ${curriculum.name}`});
      }
      return rtn;
    },
    getComboboxLessons: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      for(const lesson of state.lessons){
        rtn.push({value: lesson.lesson_code, text: `${lesson.lesson_code} : ${lesson.name}`});
      }
      return rtn;
    },
    getComboboxToolbarPositions: (state) => (allowEmpty: boolean) => {
      const rtn: any[] = [];
      if(allowEmpty){
        rtn.push({value: "", text: "-"});
      }
      return rtn.concat(Common.GetComboboxToolbarPositionArray());
    },
    getCourseNameByValue: (state, getters) => (code: string) => {
      if(!code){
        return "";
      }
      const course = state.courses.filter(x => x.course_code == code);
      return course.length > 0 ? course[0].name : `${code}(削除)`;
    },
    getCampusNameByValue: (state, getters) => (code: string) => {
      if(!code){
        return "";
      }
      const campus = state.campuses.filter(x => x.campus_code == code);
      return campus.length > 0 ? campus[0].name : `${code}(削除)`;
    },
    getClassNameByValue: (state, getters) => (code: string) => {
      if(!code){
        return "";
      }
      const classification = state.classifications.filter(x => x.class_code == code);
      return classification.length > 0 ? classification[0].name : `${code}(削除)`;
    },
    getSubjectNameByValue: (state, getters) => (code: string) => {
      if(!code){
        return "";
      }
      const subject = state.subjects.filter(x => x.subject_code == code);
      return subject.length > 0 ? subject[0].name : `${code}(削除)`;
    },
    // 講座オプション有無
    isOptionLessonActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Lesson && x.active_flg).length > 0;
    },
    // レポートオプション有無
    isOptionReportActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Report && x.active_flg).length > 0;
    },
    // 試験オプション有無
    isOptionApprovalExamActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.ApprovalExam && x.active_flg).length > 0;
    },
    // ぱんぷきんデータ連携オプション有無
    isOptionDataTransferActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.DataTransfer && x.active_flg).length > 0;
    },
    // 受講レポートマスタ使用有無
    isOptionStudentSubjectReportActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.StudentSubjectReport && x.active_flg).length > 0;
    },
    // 受講レポートマスタ手動編集可否
    isOptionAllowEditStudentSubjectReportActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.AllowEditStudentSubjectReport && x.active_flg).length > 0;
    },
    // 締切後提出許可オプション有無
    isOptionAllowSubmitOverLimitActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.AllowSubmitOverLimit && x.active_flg).length > 0;
    },
    // 動画視聴オプション有無
    isOptionMovieActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.Movie && x.active_flg).length > 0;
    },
    // 教師SSOオプション有無
    isOptionTeacherSsoActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.TeacherSso && x.active_flg).length > 0;
    },
    // 過去の返却レポート非表示オプション有無
    isOptionHidePastReportsActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.HidePastReports && x.active_flg).length > 0;
    },
    // 返却レポートの採点者名非表示オプション有無
    isOptionHideScoredUserNameActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.HideScoredUserName && x.active_flg).length > 0;
    },
    // 試験結果WEB閲覧オプション有無
    isOptionExamResultWebViewActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.ExamResultWebView && x.active_flg).length > 0;
    },
    // 試験手動公開オプション有無
    isOptionExamManualPublishActive: state => {
      return state.currentUser.school_options.filter((x: any) => x.option_no == Common.SchoolOptionEnum.ExamManualPublish && x.active_flg).length > 0;
    },
    // ヘッダメニュー 権限・オプションにより制御
    headerMenus: (state, getters) => {
      
      const menus: Menu[] = new Array<Menu>();
      
      if(state.currentUser == null){
        return menus;
      }

      if(state.currentUser.role == Common.RoleEnum.Student){
        if(getters.isOptionReportActive){
          menus.push(new Menu("レポート一覧", "file-alt", `/${state.school_url_prefix}/student_site/sheet_list`));
          if(!getters.isOptionHidePastReportsActive){
            menus.push(new Menu("過去のレポート", "file-alt", `/${state.school_url_prefix}/student_site/sheet_archive_list`));
          }
        }

        if(getters.isOptionLessonActive){
          menus.push(new Menu("講座一覧", "file-alt", `/${state.school_url_prefix}/student_site/lesson_class_list`));
        }
      }else if(state.currentUser.role == Common.RoleEnum.DataTransfer){
        menus.push(new Menu("ユーザー管理", "address-card", "/teacher_site/user_edit"));
        menus.push(new Menu("成績CSV出力", "download", "/teacher_site/saiten_result_download"));
        menus.push(new Menu("マスタ管理", "file-invoice", "/teacher_site/course_list"));
      }else{
        menus.push(new Menu("ユーザー管理", "address-card", "/teacher_site/user_edit"));

        if(getters.isOptionReportActive){
          menus.push(new Menu("レポート一覧", "file-alt", "/teacher_site/sheet_list"));
          if(state.currentUser.role == Common.RoleEnum.Admin || state.currentUser.role == Common.RoleEnum.Teacher1 || state.currentUser.base_sheet_edit_auth){
            menus.push(new Menu("レポートマスタ管理", "file-invoice", "/teacher_site/base_sheet_list"));
          }
        }

        if(getters.isOptionApprovalExamActive){
          menus.push(new Menu("試験一覧", "file-alt", "/teacher_site/approval_sheet_list"));
          if(state.currentUser.role == Common.RoleEnum.Admin || state.currentUser.role == Common.RoleEnum.Teacher1 || state.currentUser.base_sheet_edit_auth){
            menus.push(new Menu("試験マスタ管理", "file-invoice", "/teacher_site/approval_base_sheet_list"));
          }
        }

        if(getters.isOptionLessonActive){
          menus.push(new Menu("講座テスト一覧", "file-alt", "/teacher_site/lesson_sheet_list"));
          menus.push(new Menu("講義スケジュール管理", "file-invoice", "/teacher_site/lesson_class_list"));
        }
        
        if(state.currentUser.role == Common.RoleEnum.Admin){
          menus.push(new Menu("学校一覧", "calendar-alt", "/teacher_site/school_list"));
        }

        if(state.currentUser.role == Common.RoleEnum.Admin || state.currentUser.role == Common.RoleEnum.Teacher1){
          menus.push(new Menu("教師一覧", "graduation-cap", "/teacher_site/teacher_list"));
          menus.push(new Menu("マスタ管理", "file-invoice", "/teacher_site/course_list"));
        }

        if((state.currentUser.is_result_viewable)){
          menus.push(new Menu("生徒レポート確認", "file-invoice", "/teacher_site/student_seiseki_list"));
          menus.push(new Menu("レポート別提出状況", "file-invoice", "/teacher_site/progress_sheet_list"));
        }

        if(state.currentUser.role == Common.RoleEnum.Admin || state.currentUser.role == Common.RoleEnum.Teacher1 || state.currentUser.result_output_auth){
          menus.push(new Menu("成績CSV出力", "download", "/teacher_site/saiten_result_download"));
          menus.push(new Menu("採点枚数CSV出力", "download", "/teacher_site/saiten_count_download"));
        }

        if(getters.isOptionLessonActive && (state.currentUser.role == Common.RoleEnum.Admin || state.currentUser.role == Common.RoleEnum.Teacher1)){
          menus.push(new Menu("アンケート出力", "download", "/teacher_site/questionnaire_result_download"));
        }

        // 開発用 ローカル端末のみ表示
        if(state.currentUser.role == Common.RoleEnum.Admin && window.location.href.indexOf("http://localhost:8080/#/") != -1){
          menus.push(new Menu("QR付き画像生成", "file-invoice", "/teacher_site/qr_base_sheet_upload"));
        }

        if(window.location.href.includes("/student_ref/")){
          if(getters.isOptionReportActive){
            menus.push(new Menu("レポート一覧", "file-alt", "/teacher_site/student_ref/sheet_list"));
            menus.push(new Menu("過去のレポート", "file-alt", "/teacher_site/student_ref/sheet_archive_list"));
          }
  
          if(getters.isOptionLessonActive){
            menus.push(new Menu("講座一覧", "file-alt", "/teacher_site/student_ref/lesson_class_list"));
          }
        }
      }

      return menus;
    },
    // システム管理者か判定
    isAdmin: state => {
      return state.currentUser.role == Common.RoleEnum.Admin;
    },
    // 生徒アカウントか判定
    isStudent: state => {
      return state.currentUser.role == Common.RoleEnum.Student;
    },
    // 試験・追試験の画面か判定
    isApprovalExamSheetType: state => {
      return Common.isApprovalExamSheetType(state.sheet_type);
    }
  },
  actions: {
    showOverlay(context, payload){
      let overlayText = "処理実行中... しばらくお待ちください。";
      let isShowProgress = false;

      if (typeof payload === "string" || payload == null) {
        overlayText = payload || overlayText;
      }
      else if (typeof payload === "object") {
        overlayText = payload.overlayText || overlayText;
        isShowProgress = payload.isShowProgress || false;
      }

      context.commit("setIsShowOverlay", true);
      context.commit("setIsShowProgress", isShowProgress);
      context.commit("setProgressText", "0.0");
      context.commit("setOverlayText", overlayText);
    },
    hideOverlay(context){
      context.commit("setIsShowOverlay", false);
      context.commit("setIsShowProgress", false);
    },
    goSheetList(context){
      if(Common.isApprovalExamSheetType(context.state.sheet_type)){
        router.push('/teacher_site/approval_sheet_list');
      }else if(context.state.sheet_type == Common.SheetTypeEnum.Report){
        router.push('/teacher_site/sheet_list');
      }else{
        router.push('/teacher_site/lesson_sheet_list');
      }
    },
    goBaseSheetList(context){
      if(context.state.sheet_type == Common.SheetTypeEnum.Report){
        router.push('/teacher_site/base_sheet_list');
      }else if(Common.isApprovalExamSheetType(context.state.sheet_type)){
        router.push('/teacher_site/approval_base_sheet_list');
      }else{
        router.push('/teacher_site/lesson_class_list');
      }
    }
  },
  modules: {
  },
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
})
